export const getProccesTypesList = [
    {
        "id": 1,
        "description_TR": "Cüzdanlar Arası Para Transfer",
        "description_EN": null,
        "detail": "Cüzdanlar Arası Para Transfer",
        "customerIndicator": -1,
        "receiverIndicator": 1
    },
    {
        "id": 2,
        "description_TR": "Banka Hesabında Cüzdan Hesabına Para Transferi",
        "description_EN": null,
        "detail": null,
        "customerIndicator": 1,
        "receiverIndicator": null
    },
    {
        "id": 3,
        "description_TR": "Cüzdan Hesabından Banka Hesabına Para Transferi",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": null
    },
    {
        "id": 4,
        "description_TR": "Exchange",
        "description_EN": null,
        "detail": null,
        "customerIndicator": null,
        "receiverIndicator": null
    },
    {
        "id": 5,
        "description_TR": "Ödeme",
        "description_EN": null,
        "detail": null,
        "customerIndicator": null,
        "receiverIndicator": null
    },
    {
        "id": 6,
        "description_TR": "Fatura Ödeme",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": 1
    },
    {
        "id": 7,
        "description_TR": "Cashback",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": 1
    },
    {
        "id": 8,
        "description_TR": "FASTGiden",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": null
    },
    {
        "id": 9,
        "description_TR": "FASTGelen",
        "description_EN": null,
        "detail": null,
        "customerIndicator": 1,
        "receiverIndicator": null
    },
    {
        "id": 10,
        "description_TR": "FASTGelenIade",
        "description_EN": null,
        "detail": null,
        "customerIndicator": 1,
        "receiverIndicator": null
    },
    {
        "id": 11,
        "description_TR": "Sanal Kart Harcaması",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": null
    },
    {
        "id": 12,
        "description_TR": "Sanal Kart İade",
        "description_EN": null,
        "detail": null,
        "customerIndicator": 1,
        "receiverIndicator": null
    },
    {
        "id": 13,
        "description_TR": "Emtia İşlemleri",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": 1
    },
    {
        "id": 14,
        "description_TR": "Fiziki Altın",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": 1
    },
    {
        "id": 15,
        "description_TR": "Bağış",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": 1
    },
    {
        "id": 16,
        "description_TR": "Epin",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": 1
    },
    {
        "id": 17,
        "description_TR": "Kart Harcaması",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": null
    },
    {
        "id": 18,
        "description_TR": "Kart Harcama İadesi",
        "description_EN": null,
        "detail": null,
        "customerIndicator": 1,
        "receiverIndicator": null
    },
    {
        "id": 19,
        "description_TR": "Kart Harcama Eşleniksiz İade",
        "description_EN": null,
        "detail": null,
        "customerIndicator": 1,
        "receiverIndicator": null
    },
    {
        "id": 20,
        "description_TR": "Karta Para Yükleme",
        "description_EN": null,
        "detail": null,
        "customerIndicator": 1,
        "receiverIndicator": null
    },
    {
        "id": 21,
        "description_TR": "Karttan Para Çekme",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": null
    },
    {
        "id": 22,
        "description_TR": "Kart Bakiye Sorgulama",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": null
    },
    {
        "id": 23,
        "description_TR": "Kart Komisyon Sorgulama",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": null
    },
    {
        "id": 24,
        "description_TR": "Kart Limit Sorgulama",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": null
    },
    {
        "id": 25,
        "description_TR": "Kart Harcama İptali",
        "description_EN": null,
        "detail": null,
        "customerIndicator": 1,
        "receiverIndicator": null
    },
    {
        "id": 26,
        "description_TR": "Karta Para Yükleme İptali",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": null
    },
    {
        "id": 27,
        "description_TR": "Kart Harcama İade İptali",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": null
    },
    {
        "id": 28,
        "description_TR": "Karttan Para Çekme İptali",
        "description_EN": null,
        "detail": null,
        "customerIndicator": 1,
        "receiverIndicator": null
    },
    {
        "id": 29,
        "description_TR": "Kredi Kartı ile Fiziki Altın Alımı",
        "description_EN": null,
        "detail": null,
        "customerIndicator": null,
        "receiverIndicator": 1
    },
    {
        "id": 30,
        "description_TR": "Kart Ücreti",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": null
    },
    {
        "id": 31,
        "description_TR": "IWallet Harcaması",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": 1
    },
    {
        "id": 32,
        "description_TR": "Kredi Kartı ile Cüzdan Hesabına Para Yükleme",
        "description_EN": null,
        "detail": null,
        "customerIndicator": 1,
        "receiverIndicator": null
    },
    {
        "id": 33,
        "description_TR": "Kredi Kartı Fatura Ödeme",
        "description_EN": null,
        "detail": null,
        "customerIndicator": null,
        "receiverIndicator": 1
    },
    {
        "id": 34,
        "description_TR": "IWallet İade",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": 1
    },
    {
        "id": 35,
        "description_TR": "Cashback İade",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": 1
    },
    {
        "id": 36,
        "description_TR": "Yemek Ödemesi",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": 1
    },
    {
        "id": 37,
        "description_TR": "Yemek Kartı Harcaması",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": null
    },
    {
        "id": 38,
        "description_TR": "Yemek Kartı Harcama İadesi",
        "description_EN": null,
        "detail": null,
        "customerIndicator": 1,
        "receiverIndicator": null
    },
    {
        "id": 39,
        "description_TR": "Yemek Kartı Harcama Eşleniksiz İade",
        "description_EN": null,
        "detail": null,
        "customerIndicator": 1,
        "receiverIndicator": null
    },
    {
        "id": 40,
        "description_TR": "Yemek Kartı Bakiye Sorgulama",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": null
    },
    {
        "id": 41,
        "description_TR": "Yemek Kartı Harcama İptali",
        "description_EN": null,
        "detail": null,
        "customerIndicator": 1,
        "receiverIndicator": null
    },
    {
        "id": 42,
        "description_TR": "Yemek Kartı Harcama İade İptali",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": null
    },
    {
        "id": 48,
        "description_TR": "Hesaptan Telefon Numarasına Transfer",
        "description_EN": null,
        "detail": null,
        "customerIndicator": -1,
        "receiverIndicator": null
    },
]